import React from 'react';
import i18next from 'i18next';
import SubpageBlue from '../../SubpageBlue';
import Textbox from '../../../../AutostadtTabComponents/Tiles/Textbox';

export default function HappinessPlanner() {
    return (
        <SubpageBlue
            title={i18next.t('HappinessPlannerTitle')}
            headerChildren={<p className='body large'>{i18next.t('HappinessPlannerSubline')}</p>}
        >
            <Textbox
                text={i18next.t('HappinessPlannerText')}
                buttonText={i18next.t('HappinessPlannerBtn')}
                color='white'
                svg='as-info'
                onClick={() => {
                    window.open('https://www.autostadt.de/planer', '_blank', 'noopener,noreferrer');
                }}
            />
        </SubpageBlue>
    );
}
